<template>
  <div class="d-flex flex-wrap align-items-center">
    <div class="mr-auto">
      <p class="text-gray-5 mb-0">
        Recebimentos Futuros
      </p>
    </div>
    <p class="text-info font-weight-bold font-size-24 mb-0">
      {{ total | money }}
    </p>
  </div>
</template>
<script>
export default {
  name: "ReceivementFuture",
  props: {
    total: {
      type: Number,
      default: () => 0
    }
  }
};
</script>
